import defaultViewsRoute from '@/router/routes/default'
import anonimViewsRoute from '@/router/routes/anonim'

const routes = [
    defaultViewsRoute,
    anonimViewsRoute,
]

export default routes
